<script setup>
import BarChart from '@/components/Graphs/BarChart';
import moment from 'moment/moment';
import { getEmployeeConsumedLeaves, getIncomingLeaves } from '@/components/Attendance/Dev/services/api.service.ts';
import { getReformattedLeaves } from '@/components/Admin/LeaveSummary/utils/leaveSummaryFormatter.ts';
import EmployeeLeaveHistory from '@/components/Users/EmployeeLeaveHistory.vue';

export default {
    components: { BarChart, EmployeeLeaveHistory },
    data() {
        return {
            chartDataMaxTicks: [],
            currentPage: 1,
            limit: 10,
            year: moment().year(),
            chartData: {
                labels: [],
                datasets: [],
                x_stacked: false,
                y_stacked: false,
            },
            chartOptions: {
                responsive: true,
            },
            leaves: [],
            selectedType: null,
            leaveTypes: [
                { label: 'incoming leaves', key: 'incoming' },
                { label: 'all leaves', key: 'all' },
            ],
        };
    },
    async mounted() {
        await this.generateChart();
    },
    methods: {
        async generateChart() {
            const { data } = await getEmployeeConsumedLeaves();
            const { chartData } = getReformattedLeaves(data[0].stats);
            this.chartData.labels = chartData.labels;
            this.chartData.datasets = chartData.dataSets;
            this.generateHistory(data);
        },
        async generateHistory(data) {
            this.leaves = data[0].main[0].leaves;
        },
        async populateAllLeaves() {
            const { data } = await getEmployeeConsumedLeaves();
            this.generateHistory(data);
        },
        async selectLeaveType(type) {
            this.$Spin.show();

            try {
                switch (type) {
                    case 'incoming':
                        await this.populateIncomingLeaves();
                        break;
                    case 'all':
                        await this.populateAllLeaves();
                        break;
                }
            } catch (err) {
                console.error('error filtering incoming leaves', err);
            } finally {
                this.$nextTick(() => {
                    this.$Spin.hide();
                });
            }
        },
        async populateIncomingLeaves() {
            const { data } = await getIncomingLeaves();
            this.leaves = data[0].leaves;
        },
    },
};
</script>

<template>
    <div>
        <BarChart
            :chartdata-sets="chartData.datasets"
            :chartdata-labels="chartData.labels"
            :max-ticks="chartDataMaxTicks"
            :x-stacked="false"
            :y-stacked="false"
        />
        <br />
        <Select v-model="selectedType" filterable clearable @on-change="selectLeaveType">
            <Option v-for="leave in leaveTypes" :key="leave.key" :value="leave.key">
                {{ leave.label }}
            </Option></Select
        >
        <br />
        <EmployeeLeaveHistory :employee-leaves="leaves"></EmployeeLeaveHistory>
    </div>
</template>

<style scoped lang="scss"></style>
